import React, { useEffect, useState } from "react";
import ViewportSlideView from "components/ViewportContainer/Slide/Slide";
import { SlideViewNavigation } from "./SlideViewNavigation";

// Externals
//import cn from "classnames";

// DevExtreme componenents
import { MultiView, Item } from 'devextreme-react/multi-view';
//import ScrollView from 'devextreme-react/scroll-view';

// Component styles
import classes from "./SlideView.module.scss";

export function SlideView(props) {
  const { viewports, renderViewport, noControls, closeViewport } = props;
  const [selectedIndex, setSelectedIndex] = useState(0);
  const navigationHeight = "2em";
  const multipleViewports = viewports.length > 1;

  useEffect(() => {
    setSelectedIndex(viewports.length - 1);
  }, [viewports.length]);

  const multiViewContainerStyle = {
    paddingTop: multipleViewports ? navigationHeight : 0
  };

  const onOptionChanged = (args) => {
    if (args.name === 'selectedIndex') {
      setSelectedIndex(args.value);
    }
  };

  const isViewportEnabled = (index) => {
    return viewports.length - 1 === index;
  };

  function renderSlide(index, vp) {
    return (
      <ViewportSlideView
        viewport={vp}
        renderViewport={renderViewport}
        closeViewport={closeViewport}
        isEnabled={isViewportEnabled(index)}
        noControls={noControls}
      />
    );
  }

  return (viewports && viewports.length > 0
    ? (
      <div style={{ overflow: "auto", height: "100%" }}>
        <div className={classes.rootContainer}>
          <SlideViewNavigation
            classes={classes}
            viewports={viewports}
            visible={multipleViewports}
            height={navigationHeight}
            selectedIndex={selectedIndex}
            onSelectedIndexChanged={setSelectedIndex}
          />
          <div className={classes.multiViewContainer} style={multiViewContainerStyle} >
            <MultiView
              height={"100%"}
              selectedIndex={selectedIndex}
              onOptionChanged={onOptionChanged}
              loop={false}
              animationEnabled={true}
            >
              {viewports.map((vp, index) => (
                <Item
                  key={index}
                  render={() => renderSlide(index, vp)}
                />
              ))}
            </MultiView>
          </div>
        </div>
      </div >
    ) : null
  )
}